import { OperationImportContextModel } from '../operation-import-context-model';

export class MicrosoftOfficeOperationPermanentAuditContextModel extends OperationImportContextModel {
  providerPolicy: string;
}
